import { render, staticRenderFns } from "./evaluateCompany.vue?vue&type=template&id=2cd2a37c&scoped=true"
import script from "./evaluateCompany.vue?vue&type=script&lang=js"
export * from "./evaluateCompany.vue?vue&type=script&lang=js"
import style0 from "./evaluateCompany.vue?vue&type=style&index=0&id=2cd2a37c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2a37c",
  null
  
)

export default component.exports